import User from '@/models/user/user.model';
import { ENDPOINTS } from '@/settings/endpoints';

export interface DexUser {
  email: string;
  id: number;
  name: string;
  token: string;
  role: string;
}

class DexUserService {
  static async fetchDexUser(): Promise<DexUser> {
    const d = User.getUserToken();
    const dexAuthEndpoint = ENDPOINTS.dexAuth || '';

    const response = await fetch(`${dexAuthEndpoint}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        d,
      }),
    });

    const jsonResponse = await response.json();

    if (response.status !== 200) {
      throw new Error(`Erro ao se autenticar com o Dex: ${jsonResponse}`);
    }

    const { token, user } = jsonResponse;
    const { email, id, role, name } = user;
    return { email, id, role, name, token };
  }
}

export default DexUserService;
